var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.photo && !_vm.processing)?_c('img',{staticClass:"authenticated-photo photo",class:{ processing: _vm.processing },attrs:{"src":_vm.photo,"alt":"Image"}}):_c('Spinner',{staticClass:"spinner"})
}
var staticRenderFns = []

export { render, staticRenderFns }